"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isNil = _interopRequireDefault(require("./isNil"));

var parseJSON = function parseJSON(jsonString) {
  if ((0, _isNil["default"])(jsonString)) {
    throw new Error('jsonString was nil');
  }

  try {
    return JSON.parse(jsonString);
  } catch (error) {
    throw error;
  }
};

var _default = parseJSON;
exports["default"] = _default;